import { useLocation } from 'react-router-dom';
import { Clock } from 'lucide-react';

/**
 * Generic placeholder page for "Coming Soon" features.
 * Used for Inventory, Training sub-pages, M-1003 sub-pages, Document Library, and Customers & Contacts.
 */
const PlaceholderPage = ({ title }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-6">
        <Clock className="w-8 h-8 text-gray-400" />
      </div>
      <h1 className="text-2xl font-bold text-[#323033] mb-2">{title}</h1>
      <p className="text-[#5A5A5A]">This feature is coming soon.</p>
    </div>
  );
};

// Pre-configured placeholder pages for specific routes
export const InventoryPage = () => <PlaceholderPage title="Inventory" />;

// Training sub-pages
export const TrainingDashboardPage = () => <PlaceholderPage title="Training Dashboard" />;
export const TrainingHSEPage = () => <PlaceholderPage title="HSE" />;
export const TrainingJobRolesPage = () => <PlaceholderPage title="Job Roles" />;
export const TrainingFunctionSpecificPage = () => <PlaceholderPage title="Function Specific" />;
export const SafetyCouncilPage = () => <PlaceholderPage title="Safety Council" />;

// M-1003 sub-pages
export const M1003B1sPage = () => <PlaceholderPage title="B1s" />;
export const M1003AuditsPage = () => <PlaceholderPage title="Audits" />;
export const M1003NCRsPage = () => <PlaceholderPage title="NCRs" />;
export const M1003MDLPage = () => <PlaceholderPage title="MDL" />;
export const M1003ApprovedVendorsPage = () => <PlaceholderPage title="Approved Vendor List" />;

// Top-level placeholder pages
export const DocumentLibraryPage = () => <PlaceholderPage title="Document Library" />;
export const CustomersContactsPage = () => <PlaceholderPage title="Customers & Contacts" />;
